import {Component, NgZone, OnInit, OnDestroy} from '@angular/core';
import {Store} from '@ngrx/store';
import {MatDialog} from '@angular/material';
import {Observable} from 'rxjs/Observable';

import {PaymentModel, PaymentStoreModel, PaymentFormModel} from './payment.model';
import PaymentForm from './payment.form';
import {ModalComponent} from '../popups/modal/modal.component';
import {ErrorComponent} from '../popups/error/error.component';

import {State} from '../../reducers/index';
import {SHOW_HEADER, OVERLAY_START} from '../../actions/header.action';
import {Info, INFO_PAYMENT} from '../../actions/info.action';
import {Booking, BOOKING_REQUEST} from '../../actions/booking.action';
import {GetOptions, PostOptions} from '../../services/interfaces/request.interfaces';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {AppConfig} from '../../app.config';
import {GetCredentialsResponse} from '../../effects/interfaces/info.interfaces';
import {Router} from '@angular/router';


@Component({
  selector: 'consentz-payment',
  templateUrl: './payment.template.html',
  styleUrls: ['./payment.styles.scss']
})
export class PaymentComponent implements OnInit, OnDestroy {

  public model: PaymentModel = new PaymentModel(
    JSON.parse(localStorage.getItem('currentBookingOptions')),
    JSON.parse(localStorage.getItem('currentUser')).user,
    JSON.parse(localStorage.getItem('cardToken'))
  );
  public settings = JSON.parse(localStorage.getItem('settings')).type;
  public storeData: PaymentStoreModel = new PaymentStoreModel();
  public accountId: string;
  public clientSecret: string;
  public publishableKey: string;
  public stripe: any;
  public options: any;
  public elements: any;
  public style: any;
  public card: any;
  public invoiceId: number;
  public urlPrepare: string;
  public paymentId: any;
  public clinicId = JSON.parse(localStorage.getItem('clinicId'));
  public appointment = JSON.parse(localStorage.getItem('Appointment'));

  // private form: PaymentForm;
  private apiUrl: string = AppConfig.apiUrl;
  public form = document.getElementById('payment-form');
  private appointmentId: number;
  private prepayId: number;


  constructor(
    public dialog: MatDialog,
    private _zone: NgZone,
    private router: Router,
    private httpClient: HttpClient,
    private store: Store<State>
  ) {

    // hide header, allow ovelay, get payment data
    this.store.dispatch({type: SHOW_HEADER});
    this.store.dispatch({type: OVERLAY_START});
    this.store.dispatch({
      type: BOOKING_REQUEST,
      payload: {
        requestUrl: '/settings'
      }
    });

    // subscribtion on widget data, local selections, creeate reactive form
    this.storeData.subscribtion.booking$ = store.select<any>('booking').subscribe((data: Booking) => {
      if (Object.keys(data).find(key => key === 'primaryFontColour')) {
        this.model.currentBookingOptions = data;
      }
      if (data['settings']) {
        this.settings = data['settings'].type;
      }
      this.model.changeDetectorRefTimeout = setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      });
    });
    if (this.appointment.totalCost === '0.00') {
      this.router.navigate([localStorage.getItem('AppId') + '/confirmed']);
    }

    this.getInvoiceId();
    this.storeData.info$ = store.select<any>('info');
    // this.form = new PaymentForm(new PaymentFormModel(this.model.user.email), this.dialog, this._zone, store);
    this.model.changeDetectorRefTimeout = setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    });
    this.options = {
      handlers: {
        success: this.successSettingsRequest.bind(this),
        error: this.error.bind(this)
      },
      body: {
        clinicId: this.clinicId,
        amount: this.appointment.totalCost
      }
    };
    this.postClientSecret(this.options);
  }

  // // delete card data
  // public deleteCard(): void {
  //   localStorage.removeItem('cardToken');
  //   this.model.cardToken = null;
  //   this.store.dispatch({type: OVERLAY_START});
  //   this.store.dispatch({
  //     type: INFO_PAYMENT,
  //     payload: {
  //       type: 'delete'
  //     }
  //   });
  // }

  public submitForm(ev): void {
    ev.preventDefault();
    this.stripe.confirmCardPayment(this.clientSecret, {
      payment_method: {
        card: this.card,
        billing_details: {
          name: JSON.parse(localStorage.getItem('currentUser')).user.firstName + ' ' + JSON.parse(localStorage.getItem('currentUser')).user.lastName
        }
      }
    }).then((result) => {
      if (result.error) {
        const displayError = document.getElementById('card-errors');
        displayError.textContent = result.error.message;
        let options;
        if (this.settings === 'Deposit') {
          options = {
            handlers: {
              success: this.successPayment.bind(this),
              error: this.error.bind(this)
            },
            body: {
              prepayId: this.prepayId
            }
          };
        } else {
          options = {
            handlers: {
              success: this.successPayment.bind(this),
              error: this.error.bind(this)
            },
            body: {
              paymentId: this.paymentId
            }
          };
        }
        this.postPayFullFailed(options);
      } else if (result.paymentIntent.status === 'succeeded') {
        let options;
        if (this.settings === 'Deposit') {
          options = {
            handlers: {
              success: this.successPayment.bind(this),
              error: this.error.bind(this)
            },
            body: {
              paymentIntentId: result.paymentIntent.id,
              paymentMethod: result.paymentIntent.payment_method,
              appointmentId: this.appointment.id,
              prepayId: this.prepayId
            }
          };
        } else {
          options = {
            handlers: {
              success: this.successPayment.bind(this),
              error: this.error.bind(this)
            },
            body: {
              paymentIntentId: result.paymentIntent.id,
              paymentMethod: result.paymentIntent.payment_method,
              appointmentId: this.appointment.id,
              paymentId: this.paymentId
            }
          };
        }

        this.postPayFull(options);
        this.model.disabledAfterPaymentForBlockingDoubleClick = true;
        this.store.dispatch({ type: OVERLAY_START });
        this.router.navigate([localStorage.getItem('AppId') + '/confirmed']);
      }
    });
  }

  public successPayment(response: any): void {
    console.log(response);
  }

  public ngOnInit(): void {
    // subscribtion on local selections, set to the reactive form
    this.model.changeDetectorRefTimeout = setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    });
  }

  public successSettingsRequest(response: any): void {
    this.accountId = response.accountId;
    this.clientSecret = response.client_secret;
    this.publishableKey = response.publishableKey;

    this.stripe = Stripe(this.publishableKey, {stripeAccount: this.accountId});
    this.elements = this.stripe.elements();
    this.style = {
      bace: {
        color: '#32325d',
      }
    };

    this.card = this.elements.create('card', {hidePostalCode: true, style: this.style});

    this.card.on('change', (event) => {
      const displayError = document.getElementById('card-errors');
      if (event.error) {
        displayError.textContent = event.error.message;
      } else {
        displayError.textContent = '';
      }
    });

    this.card.mount('#card-element');
  }

  public error(httpErrorResponse: HttpErrorResponse): void {
    console.log(httpErrorResponse);
  }

  public postClientSecret<TRequestBody, TResponseBody>(options: any): any {
    return this.httpClient
      .post<TResponseBody>(this.apiUrl + `/online-booking/stripe/intent`, options.body)
      .subscribe(options.handlers.success, options.handlers.error);
  }

  public postPayFull<TRequestBody, TResponseBody>(options: any): any {
    const url = this.settings === 'Deposit' ? `/online-booking/stripe/prepay` : `/online-booking/stripe/pay`;
    return this.httpClient
      .post<TResponseBody>(this.apiUrl + url, options.body)
      .subscribe(options.handlers.success, options.handlers.error);
  }

  public postPayFullFailed<TRequestBody, TResponseBody>(options: any): any {
    const url = this.settings === 'Deposit' ? `/online-booking/stripe/prepay/failed` : `/online-booking/stripe/pay/failed`;
    return this.httpClient
      .post<TResponseBody>(this.apiUrl + url, options.body)
      .subscribe(options.handlers.success, options.handlers.error);
  }

  public getInvoiceId<TRequestBody, TResponseBody>(): any {
    const urlPrepare = this.settings === 'Deposit'
      ? `/online-booking/invoice/prepare/${JSON.parse(localStorage.getItem('Appointment')).eventId}/prepay`
      : `/online-booking/invoice/prepare/${JSON.parse(localStorage.getItem('Appointment')).eventId}`;
    const options = {
      handlers: {
        success: this.successInvoiceIdRequest.bind(this),
        error: this.error.bind(this)
      },
      body: {
        practitioner: localStorage.getItem('practitionerId'),
        invoiceItems: [
          {
            itemCount: 1,
            discount: 0,
            inventoryAndPriceListId: JSON.parse(localStorage.getItem('data')).price.id
          }
        ]
      }
    };
    return this.httpClient
      .post<TResponseBody>(this.apiUrl + urlPrepare, options.body)
      .subscribe(options.handlers.success, options.handlers.error);
  }

// unsubscribe from store
  public ngOnDestroy(): void {
    clearTimeout(this.model.changeDetectorRefTimeout);
    if (this.storeData.subscribtion && this.storeData.subscribtion.info$) {
      this.storeData.subscribtion.info$.unsubscribe();
    }
    if (this.storeData.subscribtion && this.storeData.subscribtion.booking$) {
      this.storeData.subscribtion.booking$.unsubscribe();
    }
  }
  private successInvoiceIdRequest(response: any): void {
    if (this.settings === 'Deposit') {
      this.appointmentId = response.appointmentId;
      this.prepayId = response.prepayId;
    } else {
      this.invoiceId = response.invoiceId;
      this.paymentId = response.paymentId;
    }
  }

  // // open angular material dialog
  // private openDialog(event: any): void {
  //   event.stopPropagation();
  //   const dialogRef = this.dialog.open(ModalComponent, {
  //     width: '90%'
  //   });
  // }
}



// WEBPACK FOOTER //
// /Users/dtrubetskoi/Desktop/projects/online-booking-widget/src/app/components/payment/payment.component.ts